import { BabyLoanSmallCalculator } from "../SmallCalculator/BabyLoanSmallCalculator";

/**
 * @Shortcode
 *
 * @title "Babaváró hitel kalkulátor (Erste)"
 * @shortcode "baby_loan_erste_small"
 * @slug "babavaro-hitel-erste"
 * @type "calculator"
 */
export class BabyLoanErsteSmallCalculator extends BabyLoanSmallCalculator {
	public static defaultProps = {
		...BabyLoanSmallCalculator.defaultProps,
		variant: "erste",
		outsideTitleLink: "/erste-babavaro-hitel/",
	};

	protected getComponentName(): string {
		return `${super.getComponentName()}.BabyLoanErsteSmallCalculator`;
	}
}

export default BabyLoanErsteSmallCalculator;
